module.exports = __webpack_public_path__ + "img/229.acd14c05.jpg";